import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { RouterLink } from '@angular/router';
import { RoutesConst } from '../shared/route-const';

@Component({
  selector: 'app-home-tiles',
  imports: [RouterLink, MatIconModule, MatButtonModule, FormsModule, MatInputModule, MatFormFieldModule],
  templateUrl: './home-tiles.component.html',
  styleUrl: './home-tiles.component.scss',
})
export class HomeTilesComponent {
  routesConst = RoutesConst;
  searchValue = '';

  search() {
    if (!this.searchValue) return;
    window.location.href = '/help/searchresults?search=' + encodeURIComponent(this.searchValue);
  }
}
